import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const LeaveTypes = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.availabilityLeaveType,
      list: REDUCER_KEY.availabilityLeaveTypes
    }}
    config={config}
    permissions={permissions}
  />
);

LeaveTypes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default LeaveTypes;
